import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ModalEditPage } from './modal-edit';
@NgModule({
  declarations: [
    ModalEditPage,
  ],
    imports: [
      IonicPageModule.forChild(ModalEditPage),
  ],
  exports: [
    ModalEditPage
  ]
})
export class ModalEditPageModule {}


// WEBPACK FOOTER //
// ./src/pages/modal-edit/modal-edit.module.ts